import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Resolve,Router, RouterStateSnapshot } from '@angular/router';
import { FormSessionCanDeactivate } from '../../shared';

@Component({
  selector: 'app-assement',
  templateUrl: './assement.component.html',
  styleUrls: ['./assement.component.css']
})
export class AssementComponent extends FormSessionCanDeactivate {
  public name: any;
  public object: any;
  constructor(
    private route: ActivatedRoute,
  ) {
    super();
  }
  ngOnInit() {
    this.route.params.subscribe(params => this.name = params);
    if(this.name.name == "postopp"){
      this.object= {
        'imgurl': "M33.jpg",
        'patname':"Sheldon Reynolds",
        'patdob':"DOB: 08/29/1949 | 69 Years | Male",
        'assign':"04/17/2018",
        'completed':"04/18/2018"
        
      }
    }
    else if(this.name.name == "preopp") {
      this.object= {
        'imgurl': "avatar-2.jpg",
        'patname':"Virginia Erickson",
        'patdob':"DOB: 05/12/1950 | 68 Years | Female",
        'assign':"04/06/2018",
        'completed':"04/07/2018"
      }
    }
    
  }

}
